<template>
  <div>
    <div class="card">
      <div class="card-body">
        <div class="d-flex with-media">
          <div class="p-2 w-100">
            <div class="media">
              <img src="/static/img/blue_2@3x.png"/>
              <div class="media-body">
                <h1>{{classInfo.class_name}}</h1>
                <div><span class="gray">과목</span> {{classInfo.cate_code_name}}  ·  <span class="gray">클래스 인원 </span> <span class="number">{{classInfo.class_user_cnt}}</span>  · <span class="gray">담당선생님</span> {{classInfo.class_manager_name}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card second-card">
      <div class="card-body el-tabs__content">
        <div class="d-flex">
          <div class="p-2">
            <!-- <h2>성적분포</h2> -->
          </div>
        </div>

        <el-row :gutter="40">
          <el-col :span="10">
            <fieldset>
              <div class="d-flex">
                <div class="p-2">
                 <h2>커리큘럼 <span class="number mint">{{classExamTableData.length}}</span></h2>
                </div>
              </div>
              <stone-data-table
                table-ref="classExamTable"
                :columns="classExamTableColumns"
                :data="classExamTableData"
                :table-props="classExamTableProps"
                :current-row="currentRow"
                :loading="examSearchLoading"
                :page-size="emptyPageSize"
                :pagination-props="emptyPaginationProps"
                @row-click="classExamRowClickHandler">
              </stone-data-table>
            </fieldset>
          </el-col>
          <el-col :span="14">
            <fieldset>
              <div class="d-flex">
                <div class="p-2">
                 <h2>클래스 인원 <span class="number mint">{{classUserData.length}}</span></h2>
                </div>
                <div class="ml-auto p-2">
                  <button type="button" class="btn mint addUser-middle" :disabled="classUserSelection.length === 0" @click="openSendGrade">성적표 알림톡 보내기</button>
                </div>
              </div>
              <stone-data-table
                ref="classUserTable"
                class="no-left-margin small-td"
                table-ref="classUserTable"
                :loading="classSearchLoading"
                :columns="classUserColumns"
                :data="classUserData"
                :table-props="classUserTableProps"
                :page-size="emptyPageSize"
                :pagination-props="emptyPaginationProps"
                @selection-change="handleSelectionChange"
                @row-click="classUserRowClickHandler">
              </stone-data-table>
            </fieldset>
          </el-col>
        </el-row>

      </div>
    </div>

    <sendGradeNotification ref="sendGrade" title="회독" @confirm-click="sendGradeNew"></sendGradeNotification>

  </div>
</template>

<script>

import common from '@/modules/common'
import sendGradeNotification from '@/pages/components/sendGradeNotification.vue'

export default {
  name: 'M060302',
  mixins: [common.mixins],
  components: {sendGradeNotification},
  data () {
    return {
      classInfo: {
        class_seq: 0,
        cate_code: '',
        cate_code_name: '',
        class_name: '',
        class_manager: '',
        class_manager_name: '',
        class_user_cnt: 0,
        memo: '',
        use_yn: 'Y',
        class_user: []
      },
      classUserTableProps: {height: this.getScreenHeight(70), rowClassName: this.membershipRowClassName},
      classUserData: [],
      classUserColumns: [
        {label: '', prop: 'chk', align: 'center', type: 'selection'},
        {label: 'No', align: 'center', type: 'index', width: 50},
        {label: '이름', prop: 'user_name', align: 'center'},
        {label: '전화번호', prop: 'phone', align: 'center', formatter: this.columnFormatterPhone},
        {label: '학교', prop: 'school_name', align: 'left'}
      ],
      classExamTableProps: {height: this.getScreenHeight(70), highlightCurrentRow: true},
      classExamTableData: [],
      classExamTableColumns: [
        {label: 'No', align: 'center', type: 'index', width: 50},
        // {label: '교재번호', prop: 'book_seq', align: 'center', width: 100},
        {label: '커리큘럼명', prop: 'book_name', align: 'left', width: 200}
      ],
      examSearchLoading: false,
      classSearchLoading: false,
      currentRow: null,
      classUserSelection: []
    }
  },
  beforeCreate () {
    if (this.$route.params.class_seq === undefined || this.$route.params.class_seq === 0) {
      this.$router.push({name: 'M060201'})
    }
  },
  created () {
    const classSeq = this.$route.params.class_seq
    this.loadInfo(classSeq)
    this.retrieveClassExamBook(classSeq)
    // this.retrieveClassUser(classSeq)
  },
  methods: {
    // 클래스 정보 조회
    loadInfo (classSeq) {
      common.axios.get('/class/info/' + classSeq)
        .then(response => {
          const result = response.data
          Object.keys(this.classInfo).forEach(key => {
            this.classInfo[key] = result[key]
          })
        })
    },
    retrieveClassExamBook (classSeq) {
      this.examSearchLoading = true
      common.axios.post('/grade/class/book', {class_seq: classSeq})
        .then(response => {
          this.examSearchLoading = false
          this.classExamTableData = response.data
        })
        .catch(() => {
          this.examSearchLoading = false
        })
    },
    retrieveExamClassUser (param) {
      this.classSearchLoading = true
      common.axios.post('/class/user/book', param)
        .then(response => {
          this.classSearchLoading = false
          this.classUserData = response.data
        })
        .catch(() => {
          this.classSearchLoading = false
        })
    },
    retrieveExam (param) {
      this.examSearchLoading = true
      common.axios.post('/grade/exam/book', {class_seq: param.class_seq, class_user_seq: param.class_user_seq})
        .then(response => {
          this.examSearchLoading = false
          this.classExamTableData = response.data
        })
        .catch(() => {
          this.examSearchLoading = false
        })
    },
    retrieveClassUser (classSeq) {
      this.classSearchLoading = true
      common.axios.get('/class/user/in/' + classSeq)
        .then(response => {
          this.classSearchLoading = false
          this.classUserData = response.data
        })
        .catch(() => {
          this.classSearchLoading = false
        })
    },
    classUserRowClickHandler (row) {
      // console.log('classUserRowClickHandler row : ', row)
      // this.currentRow = row
      // this.retrieveExam(row)
      this.$router.push({name: 'M060303', params: row})
    },
    classExamRowClickHandler (row) {
      // console.log('classExamRowClickHandler row : ', row)
      // this.$router.push({name: 'M060303', params: row})
      this.currentRow = row
      this.retrieveExamClassUser(row)
    },
    handleSelectionChange (value) {
      this.classUserSelection = value
      const dataTable = this.$refs.classUserTable.$refs.classUserTable.$refs.elTable
      this.classUserSelection.forEach(row => {
        if (row.user_use_yn === 'N') {
          dataTable.toggleRowSelection(row, false)
        }
      })
    },
    openSendGrade () {
      this.handleSendGradeDialog()
    },
    sendGrade () {
      this.$confirm('성적표 알림톡을 발송하시겠습니까?', '', {})
        .then(() => {
          const classUser = this.classUserSelection.filter(x => x.user_use_yn === 'Y')
          classUser.map(x => {
            x.class_name = this.classInfo.class_name
            x.class_user_name = x.user_name
          })
          common.axios.post('/exam/kakao/book', {seq: this.currentRow.book_seq, title: this.currentRow.book_name, users: classUser})
            .then(response => {
              const result = response.data
              if (result.status === 1) {
                this.$message('회독 성적표가 발송되었습니다.')
                const dataTable = this.$refs.classUserTable.$refs.classUserTable.$refs.elTable
                this.classUserSelection.forEach(row => {
                  dataTable.toggleRowSelection(row, false)
                })
                this.classUserSelection = []
              } else {
                this.$message.warning(result.message)
              }
            })
        })
        .catch(() => {})
    },
    sendGradeNew (sendType) {
      const classUser = this.classUserSelection.filter(x => x.user_use_yn === 'Y')
      classUser.map(x => {
        x.class_name = this.classInfo.class_name
        x.class_user_name = x.user_name
      })
      common.axios.post('/exam/kakao/book', {seq: this.currentRow.book_seq, title: this.currentRow.book_name, users: classUser, send_type: sendType})
        .then(response => {
          const result = response.data
          if (result.status === 1) {
            this.$message('회독 성적표가 발송되었습니다.')
            const dataTable = this.$refs.classUserTable.$refs.classUserTable.$refs.elTable
            this.classUserSelection.forEach(row => {
              dataTable.toggleRowSelection(row, false)
            })
            this.classUserSelection = []
          } else {
            this.$message.warning(result.message)
          }
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/M060302.vue